// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q2/2023science_fiction/controller.php?enews=';
const WAP_API = process.env.VUE_APP_CQCB_API;
const COMPOSITION = 'vote/composition/index.php?action=list';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

// 获取文心课堂下的作文列表
const getArticleList = (page: number) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
    },
  });
};
enum WorkType {
  'teacher' = 1,
  'notes' = 2,
}
interface IHomeData {
  page: number;
  workType: WorkType.notes | WorkType.teacher;
  search?: string;
}

// 获取首页学校列表
const getHomeSchoolList = ({ page, keyword, type }: any) => {
  return http.get(`${COMPOSITION}`, {
    params: {
      page,
      type,
      keyword,
      limit: 30,
      activity_id: 17,
    },
  });
};

// 获取助力人数
const getVoteNumTotal = () => {
  return http.get(`${urlPrefix}user-helper`);
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

// 获取用户的作文账户信息
const fetchUserState = () => {
  return http.get(`${WAP_API}/api/composition/user/indexSetting`, {});
};

// 获取广告 1: 首页； 2:投稿广告位； 3: 详情广告位 4: 我要参赛
const fetchAds = (workType: number) => {
  return http.get(`${urlPrefix}ads`, {
    params: {
      workType,
    },
  });
};
// 作文列表
const compositionList = ({ workType, page, search }: any) => {
  return http.get(`${urlPrefix}compositionList`, {
    params: {
      workType,
      page,
      search,
    },
  });
};
// 作文详情
const compostionDetail = (id: string | number) => {
  return http.get(`${urlPrefix}compositionDetail`, {
    params: {
      id,
    },
  });
};
// 检测学生是否上传过作文
const studentUploadCheck = () => {
  return http.get(`${urlPrefix}compositionCheck`);
};

// 投稿列表
const getUserList = (page: number) => {
  return http.get(`${urlPrefix}userList`, {
    params: {
      page,
    },
  });
};

const save = (data: number) => {
  return http.post(`${urlPrefix}contacts`, qs.stringify(data), {
    headers: {},
  });
};
const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};
export {
  getBaseInfo,
  getArticleList,
  getVoteNumTotal,
  getRule,
  fetchUserState,
  getHomeSchoolList,
  fetchAds,
  compositionList,
  compostionDetail,
  studentUploadCheck,
  getUserList,
  save,
  getNews,
};